import ReorderButton from "./ReorderButton";
export default class FavoritemMenuCard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let prodTitles="";
        return (
            <div>
                <div role="button" className="row">
                    <div role="button" className="col">
                        <div className="card fave-menus-card-sub-container js-favorite-card" data-value={this.props.favId}>
                            <ul className="list-group list-group-flush text-center">
                                <li className="list-group-item">{this.props.favTitle}</li>
                                <li className="list-group-item padding-top-adjustment">
                                    <div className="row justify-content-center">
                                        { this.props.favProducts && this.props.favProducts.map(product => {
                                            if (product.name) {
                                                prodTitles = prodTitles + product.name + ", ";                                                
                                            }
                                             return (
                                                 <div role="button" className="col">
                                                        <div role="img-holder">
                                                            <img className="fave-order-image-1" src={product.productImageUrl} alt="favorite menu image" />
                                                        </div>
                                                    </div>
                                                    );
                                         })
                                        }                                     
                                    </div>
                                </li>
                                <li className="list-group-item"><span className="favourite-des">{prodTitles && prodTitles.trim().slice(0, -1)}</span></li>
                                <li>
                                    <ReorderButton reOrderButton={this.props.buttonText} favId={this.props.favId} />
                               </li>
                            </ul>
                        </div>
                    </div>
                    <div role="layout" className="row">
                        <div role="layout" className="col">
                            <div role="logo" className="fave-menu-heart-logo-image"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
